import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const PingHistoryTab = () => {
  const navigate = useNavigate();
  const [history, setHistory] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetch("/api/ping-history")
      .then((res) => res.json())
      .then((data) => setHistory(data))
      .catch((err) => console.error("Failed to load ping history", err));
  }, []);

  const filteredHistory = history.filter(
    (entry) =>
      entry.type.toLowerCase().includes(search.toLowerCase()) ||
      (entry.target && entry.target.toLowerCase().includes(search.toLowerCase())) ||
      entry.status.toLowerCase().includes(search.toLowerCase())
  );

  const exportCSV = () => {
    const headers = ["Timestamp", "Type", "Target", "Device Count", "Delivered", "Status"];
    const rows = filteredHistory.map((entry) => [
      new Date(entry.timestamp).toLocaleString(),
      entry.type,
      entry.target || "All Devices",
      entry.deviceIds.length,
      entry.delivered.length,
      entry.status,
    ]);

    let csvContent = "data:text/csv;charset=utf-8," + headers.join(",") + "\n";
    rows.forEach((rowArray) => {
      csvContent += rowArray.join(",") + "\n";
    });

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "ping_history.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div style={{ padding: "2rem", maxWidth: "1200px", margin: "0 auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <button
          onClick={() => navigate("/dashboard")}
          style={buttonStyle}
        >
          ← Back to Dashboard
        </button>
        <input
          type="text"
          placeholder="Search type, target or status..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={searchStyle}
        />
        <button
          onClick={exportCSV}
          style={{ ...buttonStyle, backgroundColor: "#28a745" }}
        >
          ⬇ Export CSV
        </button>
      </div>

      <h2 style={{ marginBottom: "1rem", marginTop: "1rem" }}>📜 Ping History</h2>

      {filteredHistory.length === 0 ? (
        <p>No ping history found.</p>
      ) : (
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={thStyle}>Timestamp</th>
              <th style={thStyle}>Type</th>
              <th style={thStyle}>Target</th>
              <th style={thStyle}>Device Count</th>
              <th style={thStyle}>Delivered</th>
              <th style={thStyle}>Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredHistory.map((entry, idx) => (
              <tr key={idx} style={{ textAlign: "center" }}>
                <td style={tdStyle}>{new Date(entry.timestamp).toLocaleString()}</td>
                <td style={tdStyle}>{entry.type}</td>
                <td style={tdStyle}>{entry.target || "All Devices"}</td>
                <td style={tdStyle}>{entry.deviceIds.length}</td>
                <td style={tdStyle}>{entry.delivered.length}</td>
                <td style={tdStyle}>{entry.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

const thStyle = {
  borderBottom: "2px solid #ddd",
  padding: "10px",
  textAlign: "left",
  background: "#f8f8f8",
  fontWeight: "bold",
};

const tdStyle = {
  padding: "10px",
  borderBottom: "1px solid #eee",
};

const buttonStyle = {
  backgroundColor: "#007bff",
  color: "white",
  padding: "10px 20px",
  border: "none",
  borderRadius: "5px",
  fontWeight: "bold",
  cursor: "pointer",
};

const searchStyle = {
  padding: "10px",
  marginLeft: "10px",
  marginRight: "10px",
  borderRadius: "5px",
  border: "1px solid #ccc",
  flexGrow: 1,
  maxWidth: "300px",
};

export default PingHistoryTab;
